export default "__VITE_ASSET__XgXB5YFK__"